import script from "./FindPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./FindPassword.vue?vue&type=script&setup=true&lang=js"

import "./FindPassword.vue?vue&type=style&index=0&id=358001fe&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358001fe"]])

export default __exports__